module.exports = __webpack_public_path__ + "static/media/no-results.52457780.jpg";